import "assets/css/grid.scss";
import "assets/css/utilities.scss";
import "assets/css/size.scss";
import "assets/css/position.scss";
import "assets/css/border.scss";
import "assets/css/spacing.scss";
import "assets/css/font.scss";
import "assets/css/dashboard.scss";
import "./Dashboard.scss";
import "assets/css/style.scss";
import logo from 'assets/images/logo.png';
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { debounce } from '../../../utils';
import * as authApis from 'apis/auth';
import Modal from 'components/common/Modal';

const navLinkClass = ({ isActive }) =>
    `sidebar-link ff-inter-medium${isActive ? ' active' : ''}`;

const NavItem = ({ to, end, icon, external, onClick, children }) => (
    <li onClick={onClick}>
        <NavLink to={to} end={end} className={navLinkClass}>
            <span className="sidebar-icon"><i className={`fa-solid ${icon}`}></i></span>
            {children}
            {external && <i className="fa-solid fa-arrow-up-right-from-square sidebar-ext"></i>}
        </NavLink>
    </li>
);

const SideBar = ({ handleMenuClick }) => {
    const navigate = useNavigate();
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const [loggingOut, setLoggingOut] = useState(false);

    const handleLogoutClick = (e) => {
        e.preventDefault();
        setShowLogoutConfirm(true);
    };

    const handleConfirmLogout = async () => {
       setLoggingOut(true);
       try {
           const response = await authApis.logout();
           if(response.data.logout){
            localStorage.removeItem('token');
            localStorage.removeItem('role');
            navigate('/');
           }
       } finally {
           setLoggingOut(false);
           setShowLogoutConfirm(false);
       }
    }
    return (
        <div className="sidebar">
            <div className="sidebar-logo d-none d-md-block">
                <a href="/">
                    <img src={logo} alt="tyren" />
                 </a>   
            </div>

            <div className="sidebar-section">
                <div className="sidebar-heading">Explore</div>
                <ul className="list-reset sidebar-nav">
                    <NavItem to="/dashboard" end icon="fa-gift" onClick={handleMenuClick}>Benefits</NavItem>

                    {/* Hidden from dashboard menu
                    <NavItem to="giveaways" icon="fa-trophy" onClick={handleMenuClick}>Giveaways</NavItem>
                    */}

                    <NavItem to="events" icon="fa-calendar-days" onClick={handleMenuClick}>Events</NavItem>
                    <NavItem to="/ride-24" icon="fa-motorcycle" external onClick={handleMenuClick}>Ride24</NavItem>
                    <NavItem to="coupons" icon="fa-tags" onClick={handleMenuClick}>Coupons</NavItem>

                    {/* Hidden from dashboard menu
                    <NavItem to="check-ticket" icon="fa-ticket" onClick={handleMenuClick}>Check My Ticket</NavItem>
                    */}
                </ul>
            </div>

            <div className="sidebar-section">
                <div className="sidebar-heading">Membership</div>
                <ul className="list-reset sidebar-nav">
                    <NavItem to="my-subscription" icon="fa-credit-card" onClick={handleMenuClick}>Subscription</NavItem>
                    <NavItem to="my-account" icon="fa-user" onClick={handleMenuClick}>Account</NavItem>
                </ul>
            </div>

            <div className="sidebar-foot">
                <button type="button" className="sidebar-link sidebar-logout ff-inter-medium" onClick={handleLogoutClick}>
                    <span className="sidebar-icon"><i className="fa-solid fa-right-from-bracket"></i></span>
                    Logout
                </button>
            </div>

            <Modal isOpen={showLogoutConfirm} onClose={() => setShowLogoutConfirm(false)} size="small">
                <div className="p-300 ff-inter-medium fs-200">
                    Are you sure you want to log out?

                    <div className="mt-200 flex jc-end">
                        <button className="btn-cancel" onClick={() => setShowLogoutConfirm(false)} disabled={loggingOut}>Cancel</button>
                        <button className="ml-100 btn-primary-outline" onClick={handleConfirmLogout} disabled={loggingOut}>
                            {loggingOut ? 'Logging out...' : 'Logout'}
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )

};

export const Dashboard = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        window.addEventListener('resize', debounce(() => {
            if (isOpen) {
                setIsOpen(false);
            }
        }, 1000));
    }, []);

    return (
        <div className="dashboard">
            <div className="topbar d-md-none h-800 flex fixed align-items-center jc-center w-full">
                <a href="/" style={{ position: 'relative', zIndex: 1 }}>
                    <img src={logo} alt="tyren" style={{ maxWidth: '192px' }} />
                </a>
                <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className={`topbar-burger${isOpen ? ' open' : ''}`}
                    aria-label="Menu"
                    aria-expanded={isOpen}
                >
                    <i className={`fa-solid ${isOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
                </button>
            </div>

            {isOpen && <div className="overlay" onClick={() => setIsOpen(false)}></div>}

            <div className={`mobile-nav fixed t-800 r-0 ${isOpen ? 'open' : ''}`}>
                <SideBar handleMenuClick={() => setIsOpen(false)}/>
            </div>

            <div className="desktop-nav h-full fixed t-0 d-none d-md-block">
                <SideBar/>
            </div>

            <div className="contentarea pt-xs-800 pt-md-none">
                <Outlet />
            </div>
        </div>
    );
}

export default Dashboard;